import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useForm, Controller, useWatch } from "react-hook-form";
import {
  makeStyles,
  Typography,
  Box,
  Container,
  Grid,
  Button,
  useMediaQuery,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  TextField
} from "@material-ui/core";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import Pagination from "@material-ui/lab/Pagination";
import divisions from "../divisions.json";


const searchList = [
  {
    storeName: "輕井澤",
    phone: "0912-3456789",
    href: "./",
  },
  {
    storeName: "輕井澤",
    phone: "0912-3456789",
    href: "./",
  },
  {
    storeName: "輕井澤",
    phone: "0912-3456789",
    href: "./",
  },
  {
    storeName: "輕井澤",
    phone: "0912-3456789",
    href: "./",
  },
];


export default function JoinSearch() {
  const isTable = useMediaQuery("(min-width:768px)");
  const useStyles = makeStyles((theme) => ({}));
  const classes = useStyles();
  return (
    <Box py={10}>
      <SearchForm />
    </Box>
  );
}

function SearchForm() {
  const theme = useTheme();
  const { handleSubmit, control, getValues, setValue, register } = useForm({
    defaultValues: {
      fullName: "",
      mobile: "",
      email: "",
    },
  });
  const district = useWatch({ control, name: "district" });
  const divisionList = Object.keys(divisions);
  const subdistrictList = district
    ? Object.keys(divisions[district]["subdivisions"])
    : [];
  function _submit(data) {
    const userInput = {
      ...data,
    };
  }
  return (
    <Box>
      <Container maxWidth="md">
        {/* Select 查詢 */}
        <Box mt={2} mb={12}>
          <Grid container>
            <Grid container item xs={12} justify="center">
              <Box mb={4}>
                <Typography color="secondary" variant="h4">
                  加盟查詢
                </Typography>
              </Box>
            </Grid>
            <Grid item container spacing={2}>
              {/* ANHCOR縣市 */}
              <Grid item xs={6}>
                <Controller
                  control={control}
                  name="district"
                  rules={
                    {
                      // required: "縣市為必填選項",
                    }
                  }
                  render={({
                    field: { onChange, ...otherField },
                    fieldState: { error },
                  }) => (
                    <FormControl
                      size="small"
                      variant="outlined"
                      fullWidth
                      error={error}
                    >
                      <InputLabel>縣市</InputLabel>
                      <Select
                        {...otherField}
                        onChange={(e) => {
                          setValue("subdistrict", "");
                          onChange(e);
                        }}
                        label="縣市"
                      >
                        {divisionList.map((item) => (
                          <MenuItem value={item}>
                            {divisions[item]["zhTW"]}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText>{error && error.message}</FormHelperText>
                    </FormControl>
                  )}
                />
              </Grid>
              {/* ANHCOR鄉鎮 */}
              <Grid item xs={6}>
                <Controller
                  control={control}
                  name="subdistrict"
                  rules={
                    {
                      // required: "地區為必填選項",
                    }
                  }
                  render={({ field, fieldState: { error } }) => (
                    <FormControl
                      size="small"
                      variant="outlined"
                      error={error}
                      fullWidth
                    >
                      <InputLabel>地區</InputLabel>
                      <Select {...field} label="地區" disabled={!district}>
                        {subdistrictList.map((item) => (
                          <MenuItem value={item}>
                            {divisions[district]["subdivisions"][item]["zhTW"]}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText>{error && error.message}</FormHelperText>
                    </FormControl>
                  )}
                />
              </Grid>
              {/* ANHCOR店名 */}
              <Grid item xs={12} md={10}>
                <Controller
                  name="storeName"
                  control={control}
                  rules={{
                    // required: "請填入姓名",
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      label="請輸入店名"
                      {...field}
                      fullWidth
                    />
                  )}
                />
              </Grid>
              {/* ANHCOR查詢btn */}
              <Grid item xs={12} md={2}>
                <Button
                  variant="contained"
                  onClick={handleSubmit(_submit)}
                  fullWidth
                  style={{
                    color: "#fff",
                    backgroundColor: theme.palette.secondary.light,
                  }}
                >
                  傳送
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Box mt={2}>
            <Typography variant="body2" align="center" style={{color:theme.palette.secondary.light}} >
              總共 {searchList.length} 間加盟店
            </Typography>
          </Box>
        </Box>

        {/* SearchList */}
        <Box>
          <SearchList />
        </Box>
      </Container>
    </Box>
  );
}

function SearchList() {
  const isPhone = useMediaQuery("(max-width:600px)");
  const history = useHistory();
  const theme = useTheme();
  const useStyles = makeStyles((theme) => ({
    table: {
      "& .MuiTableCell-root": {
        padding: "16px 0px 16px 16px",
        borderColor:theme.palette.secondary.light,
      },
    },
    tableText: {
      color: theme.palette.grey[600],
      fontSize: isPhone ? "0.8em" : "",
    },
    root: {
      '& .Mui-selected': {
        backgroundColor: 'transparent',
        color: theme.palette.secondary.light,
        },
    }

  }));
  const classes = useStyles();


  return (
    <div>
      <TableContainer component={Paper}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow selected={true}  style={{backgroundColor:theme.palette.grey[100]}} >
              <TableCell>
                <Typography className={classes.tableText}>店名</Typography>
              </TableCell>
              <TableCell align="center">
                <Typography className={classes.tableText}>電話</Typography>
              </TableCell>
              <TableCell align={isPhone ? "center" : "right"}>
                <Box mr={isPhone ? "" : "2.5em"}>
                  <Typography className={classes.tableText}>網址</Typography>
                </Box>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {searchList.map((item) => (
              <TableRow hover={true} key={item.name} className={ classes.tableRow } >
                <TableCell component="th" scope="row">
                  <Typography className={classes.tableText}>
                    {item.storeName}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography className={classes.tableText}>
                    {item.phone}
                  </Typography>
                </TableCell>
                <TableCell align={isPhone ? "center" : "right"}>
                  <Button onClick={() => history.push(item.href)}>
                    <Box display="flex" alignItems="center">
                      <Typography
                        className={classes.tableText}
                        style={{ display: isPhone ? "none" : "" }}
                      >
                        立刻前往
                      </Typography>
                      <ArrowForwardIosIcon
                        style={{
                          color: theme.palette.secondary.light,
                          width: "20px",
                          height: "20px",
                        }}
                      />
                    </Box>
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* pagination */}

      <Box mx="auto" display="flex" justifyContent="center" mt={8} >
        <Pagination  color="tranparent" count={5} siblingCount={5} className={classes.root} />
      </Box>
    </div>
  );
}
